import dayjs from 'dayjs';

export const formatCertData = (body: any, timeOffset: any) => {
    if (!body?.calibration_points) {
        return null;
    }

    return {
        id: body.device_id,
        calibrationPoints: body.calibration_points,
        calibrationTime: dayjs(body.calibration_time).add(timeOffset, 'm').format('YYYY-MM-DD'),
        expirationTime: dayjs(body.expire_time).add(timeOffset, 'm').format('YYYY-MM-DD'),
        model_info: body.model_info,
    };
};

export const formatReportData = (body: any, timeOffset: any) => {
    if (!body?.temps) {
        return null;
    }

    const startTime = body.start_time;
    const dataList = body.temps.map((temperature: any, index: any) => ({
        time: dayjs(startTime)
            .add(timeOffset, 'm')
            .add(index * 10, 'm')
            .format('YYYY-MM-DD HH:mm'),
        temperature,
    }));

    const now = dayjs();

    return {
        id: body.device_id,
        startTime: dayjs(body.start_time).add(timeOffset, 'm').format('YYYY-MM-DD HH:mm'),
        endTime: dayjs(body.end_time).add(timeOffset, 'm').format('YYYY-MM-DD HH:mm'),
        number_of_record: dataList.length,
        interval: body.interval,
        createTime: body.upload_time,
        shipper: body.meta_data?.shipper_name,
        is_normal: body.is_normal,
        track_number: body.meta_data?.shipment_number,
        timeZone: dayjs(now).format('UTCZ'),
        detailRowData: dataList,
        upperLimit: body.threshold?.upper_limit,
        lowerLimit: body.threshold?.lower_limit,
        timeLimit: body.threshold?.time_limit,
        thresholdType: body.threshold?.type === 'continuous' ? 'Single Event' : 'Cumulative',
        model_info: body.model_info,
    };
};

export type DownloadData = {
    reportData: ReturnType<typeof formatReportData>;
    certData: ReturnType<typeof formatCertData>;
};

/** The download page's view of a record, or null when the device has none; times shown in local time. */
export const toDownloadData = (body: any): DownloadData | null => {
    if (!body) return null;
    const timeOffset = dayjs().utcOffset();
    return { reportData: formatReportData(body, timeOffset), certData: formatCertData(body, timeOffset) };
};
